export default __webpack_public_path__ + "static/media/browser.61b5a7f4.webp";